/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { ForgotPasswordModel } from "../../models/forgot-password-model";

export interface ForgotPasswordPostParams {
    body?: ForgotPasswordModel
}

export function forgotPasswordPost(http: HttpClient, rootUrl: string, params: ForgotPasswordPostParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, forgotPasswordPost.PATH, 'post');

    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

forgotPasswordPost.PATH = '/api/v1/identity/forgot-password';
